/*
  カート追加ポップアップの位置同期（cart_type: notification）

  ポップアップは header section の外（layout/theme.liquid の body 直下）で出力し、
  assets/pbk-cart-notification.css で position:fixed + z-index 130 にしている
  （ヘッダーの stacking context から出して PDP モーダル / quick-view より前面に出すため）。
  fixed にすると「ヘッダー下端に貼り付く」位置をヘッダー自身から継承できないので、
  ヘッダーの実高を測って --pbk-cn-top に流し込む。

  既存の --pbk-header-h は PLP 専用 JS（pbk-loose-facets.js / pbk-jewelry-facets.js）でしか
  更新されないため流用できない。ここでは全ページで自前に測る。

  sticky-header の縮小・お知らせバーの有無・SP/PC で高さが変わるので、
  scroll / resize と、ポップアップが開く瞬間（class 変化）に追従させる。
*/
(function () {
  const popup = document.querySelector('cart-notification');
  if (!popup) return;

  const readHeaderBottom = () => {
    // .section-header = header セクションのラッパー（sticky 時も getBoundingClientRect で実位置が取れる）
    const header = document.querySelector('.section-header');
    if (!header) return null;
    const bottom = header.getBoundingClientRect().bottom;
    // 上へスクロールアウトしている場合は 0 でクランプ（画面外に浮かせない）
    return Math.max(0, Math.round(bottom));
  };

  let raf = 0;
  const sync = () => {
    if (raf) return;
    raf = requestAnimationFrame(() => {
      raf = 0;
      const bottom = readHeaderBottom();
      if (bottom === null) return;
      popup.style.setProperty('--pbk-cn-top', bottom + 'px');
    });
  };

  sync();
  window.addEventListener('scroll', sync, { passive: true });
  window.addEventListener('resize', sync);
  // 開いた瞬間（.cart-notification に active が付く）に最新のヘッダー高で合わせる。
  // AJAX 追加 → renderContents → open の流れでも確実に通る
  new MutationObserver(sync).observe(popup, {
    attributes: true,
    attributeFilter: ['class'],
    subtree: true,
  });
})();
